export default __webpack_public_path__ + "static/card-grey-3b92fff4cfb83add7ad56e4985c1c42b.png";